import { UPDATE_USER, UPDATE_USER_ERROR } from "../../actions/actionTypes";

// const initialState = {

//     user: {id: 1, name: 'John', surname:'Doeic', email:'john@doeic.com'},
// }

const initState = {
    updateStatus: null
}

export default function(state = initState , action) {
  switch (action.type) {
    case UPDATE_USER:
      return {
        ...state,
        user: action.payload,
        updateStatus: true,
        OVDE_SE_UBACUJE_ON_SUBMIT_STATE: true
      };   
    case UPDATE_USER_ERROR:
        return {
          ...state,
          updateStatus: false
        
        }
    default:
      return state;
  }
}
